/*=========================================================================================
  File Name: moduleSchedule.js
  Description: Schedule Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import state from "./moduleScheduleState.js";
import mutations from "./moduleScheduleMutations.js";
import actions from "./moduleScheduleActions.js";
import getters from "./moduleScheduleGetters.js";

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters,
};
